import { render, staticRenderFns } from "./blacklist-form.vue?vue&type=template&id=0dbe694e&"
import script from "./blacklist-form.vue?vue&type=script&lang=js&"
export * from "./blacklist-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports